export { UserMinus as default } from './UserMinus';
